<!--US Page-->
<div class="dtfglossary" >
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


    <!--Banner-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_Glossary_Header.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 id="scrollpoint" class="mbfs-home-hero__header-subtitle">
        {{ 'Glossary.Title' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi" style="text-align:center;">
          {{ 'Glossary.TitleText' | translate }}
        </p>
      </section>
    </section>

    <div class="container" *ngIf="!isCanadaPortal">
      <!---->
      <br>
      <br>
      <br>
      <div class="letterlinks">
         <h5 id="top"></h5>
         <a class="letterlinks" href="javascript:document.getElementById('A').scrollIntoView(true);" style="text-decoration: underline;">A</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('B').scrollIntoView(true);" style="text-decoration: underline;">B</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('C').scrollIntoView(true);" style="text-decoration: underline;">C</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('D').scrollIntoView(true);" style="text-decoration: underline;">D</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('E').scrollIntoView(true);" style="text-decoration: underline;">E</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('F').scrollIntoView(true);" style="text-decoration: underline;">F</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('G').scrollIntoView(true);" style="text-decoration: underline;">G</a>&nbsp;      
         <a class="letterlinks">H</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('I').scrollIntoView(true);" style="text-decoration: underline;">I</a>&nbsp;      
         <a class="letterlinks">J</a>&nbsp;
         <a class="letterlinks">K</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('L').scrollIntoView(true);" style="text-decoration: underline;">L</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('M').scrollIntoView(true);" style="text-decoration: underline;">M</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('N').scrollIntoView(true);" style="text-decoration: underline;">N</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('O').scrollIntoView(true);" style="text-decoration: underline;">O</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('P').scrollIntoView(true);" style="text-decoration: underline;">P</a>&nbsp;
         <a class="letterlinks">Q</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('R').scrollIntoView(true);" style="text-decoration: underline;">R</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('S').scrollIntoView(true);" style="text-decoration: underline;">S</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('T').scrollIntoView(true);" style="text-decoration: underline;">T</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('U').scrollIntoView(true);" style="text-decoration: underline;">U</a>&nbsp;      
         <a class="letterlinks">V</a>&nbsp;
         <a class="letterlinks">W</a>&nbsp;      
         <a class="letterlinks">X</a>&nbsp;
         <a class="letterlinks">Y</a>&nbsp;      
         <a class="letterlinks">Z</a>&nbsp;
      </div>
      <br>
      <br>
      
      <div id ="A" class="single-letter">A</div><br>
      <div class="term"> {{ 'Glossary.AcceleratedPayments' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AcceleratedPaymentsDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Add-ons' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Add-onsDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.AdvancePayments' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AdvancePaymentsDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.AdvancePercent' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AdvancePercentDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Affiliate' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AffiliateDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Alterations' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AlterationsDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Amortization' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AmortizationDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Application' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ApplicationDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Arrears' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ArrearsDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Assets' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AssetsDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Availability' | translate }} </div>
      <div class="definition"> {{ 'Glossary.AvailabilityDef' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="B" class="single-letter">B</div>
      <div class="term"> {{ 'Glossary.BadDebt' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BadDebtDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.BalloonPayment' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.BalloonPaymentDef1' | translate }}</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.BalloonPaymentDef2' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Bankruptcy' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BankruptcyDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Benificiary' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BenificiaryDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.BillOfSale' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BillOfSaleDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Binder' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BinderDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Buyout' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BuyoutDef' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="C" class="single-letter">C</div>
      <div class="term"> {{ 'Glossary.Cap' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CapDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CapitalLease' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CapitalLeaseDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CapitalizedCost' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CapitalizedCostDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CaptiveFinanceCompany' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CaptiveFinanceCompanyDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CashFlow' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.CashFlowDef1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.CashFlowDef2' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.ClosedEndLease' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Closed-EndLeaseDef1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Closed-EndLeaseDef2' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Closed-EndLeaseDef3' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Collateral' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CollateralDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CorporateResolution' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CorporateResolutionDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CorporateSecretary' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CorporateSecretaryDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Corporation' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CorporationDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.CreditReferences' | translate }} </div>
      <div class="definition"> {{ 'Glossary.CreditReferencesDef' | translate }} </div><br>
      <div class="term"> {{ 'Glossary.Cross-CorporateGuarantee' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Cross-CorporateGuaranteeDef' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="D" class="single-letter">D</div><br>
      <div class="term">DBA</div>
      <div class="definition"> {{ 'Glossary.DBA' | translate }} </div><br>
      <div class="term">Debt</div>
      <div class="definition"> {{ 'Glossary.Debt' | translate }} </div><br>
      <div class="term">Default</div>
      <div class="definition"> {{ 'Glossary.Default' | translate }} </div><br>
      <div class="term">Deficiency Balance</div>
      <div class="definition"> {{ 'Glossary.DeficiencyBalance' | translate }} </div><br>
      <div class="term">Down Payment</div>
      <div class="definition"> {{ 'Glossary.DownPayment' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>   

      <div id="E" class="single-letter">E</div>
      <div class="term">Electronic Funds Transfer (EFT)</div>
      <div class="definition"> {{ 'Glossary.ElectronicFundsTransfer(EFT)' | translate }} </div><br>
      <div class="term">Equipment</div>
      <div class="definition"> {{ 'Glossary.Equipment' | translate }} </div><br>
      <div class="term">Extension</div>
      <div class="definition"> {{ 'Glossary.Extension' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="F" class="single-letter">F</div>
      <div class="term">Fair Market Value</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.FairMarketValue1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.FairMarketValue2' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.FairMarketValue3' | translate }} </div><br>
      <div class="term">Financial Statements</div>
      <div class="definition"> {{ 'Glossary.Extension' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="G" class="single-letter">G</div>
      <div class="term">GAP</div>
      <div class="definition"> {{ 'Glossary.GAP' | translate }} </div><br>
      <div class="term">Guarantor</div>
      <div class="definition"> {{ 'Glossary.Guarantor' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="H" class="single-letter">H</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="I" class="single-letter">I</div>
      <div class="term">Implicit Rate</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.ImplicitRate1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.ImplicitRate2' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.ImplicitRate3' | translate }} </div><br>
      <div class="term">Interest</div>
      <div class="definition"> {{ 'Glossary.Interest' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="J" class="single-letter">J</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      
      <div id="K" class="single-letter">K</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="L" class="single-letter">L</div>
      <div class="term">Late Fee</div>
      <div class="definition"> {{ 'Glossary.LateFee' | translate }} </div><br>
      <div class="term">Lease</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Lease1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Lease2' | translate }} </div><br>
      <div class="term">Lease Maturity</div>
      <div class="definition"> {{ 'Glossary.LeaseMaturity' | translate }} </div><br>
      <div class="term">Lease Payments</div>
      <div class="definition"> {{ 'Glossary.LeasePayments' | translate }} </div><br>
      <div class="term">Lease Schedule</div>
      <div class="definition"> {{ 'Glossary.LeaseSchedule' | translate }} </div><br>
      <div class="term">Legal Title</div>
      <div class="definition"> {{ 'Glossary.LegalTitle' | translate }} </div><br>
      <div class="term">Lender</div>
      <div class="definition"> {{ 'Glossary.Lender' | translate }} </div><br>
      <div class="term">Lessee</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Lessee1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Lessee2' | translate }} </div><br>
      <div class="term">Liability</div>
      <div class="definition"> {{ 'Glossary.Liability' | translate }} </div><br>
      <div class="term">Lien</div>
      <div class="definition"> {{ 'Glossary.Lien' | translate }} </div><br>
      <div class="term">Lienholder</div>
      <div class="definition"> {{ 'Glossary.Lienholder' | translate }} </div><br>
      <div class="term">Limited Liability Company (LLC)</div>
      <div class="definition"> {{ 'Glossary.LimitedLiabilityCompany(LLC)' | translate }} </div><br>
      <div class="term">Limited Partnership</div>
      <div class="definition"> {{ 'Glossary.LimitedPartnership' | translate }} </div><br>
      <div class="term">Lockbox</div>
      <div class="definition"> {{ 'Glossary.Lockbox' | translate }} </div><br>
      <div class="term">Loss</div>
      <div class="definition"> {{ 'Glossary.Loss' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="M" class="single-letter">M</div>
      <div class="term">Master Lease</div>
      <div class="definition"> {{ 'Glossary.MasterLease' | translate }} </div><br>
      <div class="term">Maturity</div>
      <div class="definition"> {{ 'Glossary.Maturity' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="N" class="single-letter">N</div>
      <div class="term">Note and Security Agreement / Retail Installment Contract / Loan</div>
      <div class="definition"> {{ 'Glossary.NoteandSecurityAgreement/RetailInstallmentContract/Loan' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="O" class="single-letter">O</div>
      <div class="term">Obligation</div>
      <div class="definition"> {{ 'Glossary.Obligation' | translate }} </div><br>
      <div class="term">Open-End Lease</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Open-EndLease1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.Open-EndLease2' | translate }} </div><br>
      <div class="term">Operating Lease</div>
      <div class="definition"> {{ 'Glossary.OperatingLease' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="P" class="single-letter">P</div>
      <div class="term">Parent Corporation</div>
      <div class="definition"> {{ 'Glossary.ParentCorporation' | translate }} </div><br>
      <div class="term">Partner</div>
      <div class="definition"> {{ 'Glossary.Partner' | translate }} </div><br>
      <div class="term">Payoff</div>
      <div class="definition"> {{ 'Glossary.Payoff' | translate }} </div><br>
      <div class="term">Payment In Advance</div>
      <div class="definition"> {{ 'Glossary.PaymentInAdvance' | translate }} </div><br>
      <div class="term">Payment In Arrears</div>
      <div class="definition"> {{ 'Glossary.PaymentInArrears' | translate }} </div><br>
      <div class="term">Payment Stream</div>
      <div class="definition"> {{ 'Glossary.PaymentStream' | translate }} </div><br>
      <div class="term">Personal Guarantee</div>
      <div class="definition"> {{ 'Glossary.PersonalGuarantee' | translate }} </div><br>
      <div class="term">Power of Attorney</div>
      <div class="definition"> {{ 'Glossary.PowerOfAttorney' | translate }} </div><br>
      <div class="term">Principal</div>
      <div class="definition"> {{ 'Glossary.Principal' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="Q" class="single-letter">Q</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="R" class="single-letter">R</div>
      <div class="term">Rate Factor</div>
      <div class="definition"> {{ 'Glossary.RateFactor' | translate }} </div><br>
      <div class="term">Reposession</div>
      <div class="definition"> {{ 'Glossary.Reposession' | translate }} </div><br>
      <div class="term">Residual Value</div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.ResidualValue1' | translate }} </div>
      <div class="definition" style="padding-left: 15px; text-indent: -2em; margin-left: 20px;">&emsp;&bull;&ensp;{{ 'Glossary.ResidualValue2' | translate }} </div><br>
      <div class="term">Retail Installment Contract / Note and Security Agreement</div>
      <div class="definition"> {{ 'Glossary.RetailInstallmentContract/NoteAndSecurityAgreement' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="S" class="single-letter">S</div>
      <div class="term">Sales Tax</div>
      <div class="definition"> {{ 'Glossary.SalesTax' | translate }} </div><br>
      <div class="term">Sales Tax Exemption</div>
      <div class="definition"> {{ 'Glossary.SalesTaxExemption' | translate }} </div><br>
      <div class="term">Secretary's Certificate (Corporate Resolution)</div>
      <div class="definition"> {{ 'Glossary.SecretaryCertificate(CorporateResolution)' | translate }} </div><br>
      <div class="term">Simple Interest</div>
      <div class="definition"> {{ 'Glossary.SimpleInterest' | translate }} </div><br>
      <div class="term">Skip Payment</div>
      <div class="definition"> {{ 'Glossary.SkipPayment' | translate }} </div><br>
      <div class="term">Sole Proprietorship</div>
      <div class="definition"> {{ 'Glossary.SoleProprietorship' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="T" class="single-letter">T</div>
      <div class="term">Tax Exempt Organization</div>
      <div class="definition"> {{ 'Glossary.TaxExemptOrganization' | translate }} </div><br>
      <div class="term">Term</div>
      <div class="definition"> {{ 'Glossary.Term' | translate }} </div><br>
      <div class="term">TRAC (Terminal Rental Adjustment Clause) Lease</div>
      <div class="definition"> {{ 'Glossary.TRAC(TerminalRentalAdjustmentClause)Lease' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>      

      <div id="U" class="single-letter">U</div>
      <div class="term">Usury Laws</div>
      <div class="definition"> {{ 'Glossary.UsuryLaws' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>    
      
      <div id="V" class="single-letter">V</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="W" class="single-letter">W</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="X" class="single-letter">X</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      
      <div id="Y" class="single-letter">Y</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="Z" class="single-letter">Z</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

    </div>
    <div class="container" *ngIf="isCanadaEnglish">
      <!---->
      <br>
      <br>
      <br>
      <div class="letterlinks">
         <h5 id="top"></h5>
         <a class="letterlinks" href="javascript:document.getElementById('A').scrollIntoView(true);" style="text-decoration: underline;">A</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('B').scrollIntoView(true);" style="text-decoration: underline;">B</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('C').scrollIntoView(true);" style="text-decoration: underline;">C</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('D').scrollIntoView(true);" style="text-decoration: underline;">D</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('E').scrollIntoView(true);" style="text-decoration: underline;">E</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('F').scrollIntoView(true);" style="text-decoration: underline;">F</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('G').scrollIntoView(true);" style="text-decoration: underline;">G</a>&nbsp;      
         <a class="letterlinks">H</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('I').scrollIntoView(true);" style="text-decoration: underline;">I</a>&nbsp;      
         <a class="letterlinks">J</a>&nbsp;
         <a class="letterlinks">K</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('L').scrollIntoView(true);" style="text-decoration: underline;">L</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('M').scrollIntoView(true);" style="text-decoration: underline;">M</a>&nbsp;      
         <a class="letterlinks">N</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('O').scrollIntoView(true);" style="text-decoration: underline;">O</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('P').scrollIntoView(true);" style="text-decoration: underline;">P</a>&nbsp;
         <a class="letterlinks">Q</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('R').scrollIntoView(true);" style="text-decoration: underline;">R</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('S').scrollIntoView(true);" style="text-decoration: underline;">S</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('T').scrollIntoView(true);" style="text-decoration: underline;">T</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('U').scrollIntoView(true);" style="text-decoration: underline;">U</a>&nbsp;      
         <a class="letterlinks">V</a>&nbsp;
         <a class="letterlinks">W</a>&nbsp;      
         <a class="letterlinks">X</a>&nbsp;
         <a class="letterlinks">Y</a>&nbsp;      
         <a class="letterlinks">Z</a>&nbsp;
      </div>
      <br>
      <br>

      <div id="A" class="single-letter">A</div><br>
      <div class="term">Accelerated Payments</div>
      <div class="definition"> {{ 'Glossary.AcceleratedPayments' | translate }} </div><br>
      <div class="term">Add-ons</div>
      <div class="definition"> {{ 'Glossary.Add-ons' | translate }} </div><br>
      <div class="term">Advance Payments</div>
      <div class="definition"> {{ 'Glossary.AdvancePayments' | translate }} </div><br>
      <div class="term">Advance Percent</div>
      <div class="definition"> {{ 'Glossary.AdvancePercent' | translate }} </div><br>
      <div class="term">Affiliate</div>
      <div class="definition"> {{ 'Glossary.Affiliate' | translate }} </div><br>
      <div class="term">Alterations</div>
      <div class="definition"> {{ 'Glossary.Alterations' | translate }} </div><br>
      <div class="term">Amortization</div>
      <div class="definition"> {{ 'Glossary.Amortization' | translate }} </div><br>
      <div class="term">Application</div>
      <div class="definition"> {{ 'Glossary.Application' | translate }} </div><br>
      <div class="term">Arrears (payments)</div>
      <div class="definition"> {{ 'Glossary.Arrears' | translate }} </div><br>
      <div class="term">Assets</div>
      <div class="definition"> {{ 'Glossary.Assets' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="B" class="single-letter">B</div>
      <div class="term">Bad Debt</div>
      <div class="definition"> {{ 'Glossary.BadDebt' | translate }} </div><br>
      <div class="term">Balloon Payment</div>
      <div class="definition"> {{ 'Glossary.BalloonPayment1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.BalloonPayment2' | translate }} </div><br>
      <div class="term">Bankruptcy</div>
      <div class="definition"> {{ 'Glossary.Bankruptcy' | translate }} </div><br>
      <div class="term">Bill Of Sale</div>
      <div class="definition"> {{ 'Glossary.BillOfSale' | translate }} </div><br>
      <div class="term">Binder</div>
      <div class="definition"> {{ 'Glossary.Binder' | translate }} </div><br>
      <div class="term">Buyout</div>
      <div class="definition"> {{ 'Glossary.Buyout' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="C" class="single-letter">C</div>
      <div class="term">Cap</div>
      <div class="definition"> {{ 'Glossary.Cap' | translate }} </div><br>
      <div class="term">Capital Lease</div>
      <div class="definition"> {{ 'Glossary.CapitalLease' | translate }} </div><br>
      <div class="term">Capitalized Cost</div>
      <div class="definition"> {{ 'Glossary.CapitalizedCost' | translate }} </div><br>
      <div class="term">Captive Finance Company</div>
      <div class="definition"> {{ 'Glossary.CaptiveFinanceCompany' | translate }} </div><br>
      <div class="term">Cash Flow</div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.CashFlow1' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.CashFlow2' | translate }} </div><br>
      <div class="term">Closed-End Lease</div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.Closed-EndLease1' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.Closed-EndLease2' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.Closed-EndLease3' | translate }} </div><br>
      <div class="term">Collateral</div>
      <div class="definition"> {{ 'Glossary.Collateral' | translate }} </div><br>
      <div class="term">Conditional Sales Contract / Retail Installment Contract</div>
      <div class="definition"> {{ 'Glossary.ConditionalSales' | translate }} </div><br>
      <div class="term">Corporate Resolution</div>
      <div class="definition"> {{ 'Glossary.CorporateResolution' | translate }} </div><br>
      <div class="term">Corporate Secretary</div>
      <div class="definition"> {{ 'Glossary.CorporateSecretary' | translate }} </div><br>
      <div class="term">Corporation</div>
      <div class="definition"> {{ 'Glossary.Corporation' | translate }} </div><br>
      <div class="term">Credit References</div>
      <div class="definition"> {{ 'Glossary.CreditReferences' | translate }} </div><br>
      <div class="term">Continuing Guarantee</div>
      <div class="definition"> {{ 'Glossary.ContinuingGuarantee' | translate }} </div><br>
      <div class="term">Cross-Corporate Guarantee</div>
      <div class="definition"> {{ 'Glossary.Cross-CorporateGuarantee' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="D" class="single-letter">D</div>
      <div class="term">DBA</div>
      <div class="definition"> {{ 'Glossary.Debt' | translate }} </div><br>
      <div class="term">Debt</div>
      <div class="definition"> {{ 'Glossary.Corporation' | translate }} </div><br>
      <div class="term">Default</div>
      <div class="definition"> {{ 'Glossary.Default' | translate }} </div><br>
      <div class="term">Deficiency Balance</div>
      <div class="definition"> {{ 'Glossary.DeficiencyBalance' | translate }} </div><br>
      <div class="term">Down Payment</div>
      <div class="definition"> {{ 'Glossary.DownPayment' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>    

      <div id="E" class="single-letter">E</div>
      <div class="term">Electronic Funds Transfer (EFT)</div>
      <div class="definition"> {{ 'Glossary.EFT' | translate }} </div><br>
      <div class="term">Equipment</div>
      <div class="definition"> {{ 'Glossary.Equipment' | translate }} </div><br>
      <div class="term">Extension</div>
      <div class="definition"> {{ 'Glossary.Extension' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="F" class="single-letter">F</div>
      <div class="term">Fair Market Value</div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.FairMarketValue1' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.FairMarketValue2' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.FairMarketValue3' | translate }} </div><br>
      <div class="term">Financial Statements</div>
      <div class="definition"> {{ 'Glossary.FinancialStatements' | translate }} </div><br>
      <div class="term">Fixed Rate</div>
      <div class="definition"> {{ 'Glossary.FixedRate' | translate }} </div><br>
      <div class="term">Floating Rate</div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.FloatingRate1' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.FloatingRate2' | translate }} </div><br>      
      <div class="term">FMV (Fair Market Value) Lease - Closed-End Lease</div>
      <div class="definition"> {{ 'Glossary.FairMarketValue(FMV)Lease–WalkAway/Closed-EndLease' | translate }} </div><br>
      <div class="term">Future Value</div>
      <div class="definition"> {{ 'Glossary.FutureValue' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="G" class="single-letter">G</div>
      <div class="term">GAP</div>
      <div class="definition"> {{ 'Glossary.GAP' | translate }} </div><br>
      <div class="term">General Partnership</div>
      <div class="definition"> {{ 'Glossary.GeneralPartnership' | translate }} </div><br>
      <div class="term">Grace Period</div>
      <div class="definition"> {{ 'Glossary.GracePeriod' | translate }} </div><br>
      <div class="term">Guarantor</div>
      <div class="definition"> {{ 'Glossary.Guarantor' | translate }} </div><br>      
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="H" class="single-letter">H</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="I" class="single-letter">I</div>
      <div class="term">Inception Date</div>
      <div class="definition"> {{ 'Glossary.InceptionDate' | translate }} </div><br>
      <div class="term">Interest</div>
      <div class="definition"> {{ 'Glossary.Interest' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="J" class="single-letter">J</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="K" class="single-letter">K</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      
      <div id="L" class="single-letter">L</div>
      <div class="term">Late Fee</div>
      <div class="definition"> {{ 'Glossary.LateFee' | translate }} </div><br>
      <div class="term">Lease</div>
      <div class="definition"> {{ 'Glossary.Lease1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Lease2' | translate }} </div><br>
      <div class="term">Lease Maturity</div>
      <div class="definition"> {{ 'Glossary.LeaseMaturity' | translate }} </div><br>
      <div class="term">Lease Payments</div>
      <div class="definition"> {{ 'Glossary.LeasePayments' | translate }} </div><br>
      <div class="term">Lease Schedule</div>
      <div class="definition"> {{ 'Glossary.LeaseSchedule' | translate }} </div><br>
      <div class="term">Legal Title</div>
      <div class="definition"> {{ 'Glossary.LegalTitle' | translate }} </div><br>
      <div class="term">Lender</div>
      <div class="definition"> {{ 'Glossary.Lender' | translate }} </div><br>
      <div class="term">Lessee</div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.Lessee1' | translate }} </div>
      <div class="definition">&emsp;&ensp;{{ 'Glossary.Lessee2' | translate }} </div><br>
      <div class="term">Liability</div>
      <div class="definition"> {{ 'Glossary.Liability' | translate }} </div><br>
      <div class="term">Lien</div>
      <div class="definition"> {{ 'Glossary.Lien' | translate }} </div><br>
      <div class="term">Lienholder</div>
      <div class="definition"> {{ 'Glossary.Lienholder' | translate }} </div><br>
      <div class="term">Limited Liability Company (LLC)</div>
      <div class="definition"> {{ 'Glossary.LimitedLiabilityCompany(LLC)' | translate }} </div><br>
      <div class="term">Limited Partnership</div>
      <div class="definition"> {{ 'Glossary.LimitedPartnership' | translate }} </div><br>
      <div class="term">Loss</div>
      <div class="definition"> {{ 'Glossary.Loss' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="M" class="single-letter">M</div>
      <div class="term">Master Lease</div>
      <div class="definition"> {{ 'Glossary.MasterLease' | translate }} </div><br>
      <div class="term">Maturity</div>
      <div class="definition"> {{ 'Glossary.Maturity' | translate }} </div><br>
      <div class="term">Monthly Payment</div>
      <div class="definition"> {{ 'Glossary.MonthlyPayment' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      <div id="N" class="single-letter">N</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      <div id="O" class="single-letter">O</div>
      <div class="term">Obligation</div>
      <div class="definition"> {{ 'Glossary.Obligation' | translate }} </div><br>
      <div class="term">Obsolescence</div>
      <div class="definition"> {{ 'Glossary.Obsolescence' | translate }} </div><br>
      <div class="term">Open-End Lease</div>
      <div class="definition"> {{ 'Glossary.Open-EndLease1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Open-EndLease2' | translate }} </div><br>
      <div class="term">Operating Lease</div>
      <div class="definition"> {{ 'Glossary.OperatingLease' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="P" class="single-letter">P</div>
      <div class="term">Parent Corporation</div>
      <div class="definition"> {{ 'Glossary.ParentCorporation' | translate }} </div><br>
      <div class="term">Partner</div>
      <div class="definition"> {{ 'Glossary.Partner' | translate }} </div><br>
      <div class="term">Payoff</div>
      <div class="definition"> {{ 'Glossary.Payoff1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Payoff2' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Payoff3' | translate }} </div><br>
      <div class="term">Payment In Advance</div>
      <div class="definition"> {{ 'Glossary.PaymentInAdvance' | translate }} </div><br>
      <div class="term">Payment In Arrears</div>
      <div class="definition"> {{ 'Glossary.PaymentInArrears' | translate }} </div><br>
      <div class="term">Payment Stream</div>
      <div class="definition"> {{ 'Glossary.PaymentStream' | translate }} </div><br>
      <div class="term">Personal Guarantee</div>
      <div class="definition"> {{ 'Glossary.PersonalGuarantee' | translate }} </div><br>
      <div class="term">Power of Attorney</div>
      <div class="definition"> {{ 'Glossary.PowerOfAttorney' | translate }} </div><br>
      <div class="term">Principal</div>
      <div class="definition"> {{ 'Glossary.Principal' | translate }} </div><br>
      <div class="term">PPSA</div>
      <div class="definition"> {{ 'Glossary.PPSA' | translate }} </div><br>
      <div class="term">Prorate Tax Certificate</div>
      <div class="definition"> {{ 'Glossary.ProrateTaxCertificate' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="Q" class="single-letter">Q</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="R" class="single-letter">R</div>
      <div class="term">Rate Factor</div>
      <div class="definition"> {{ 'Glossary.RateFactor' | translate }} </div><br>
      <div class="term">Reposession</div>
      <div class="definition"> {{ 'Glossary.Reposession' | translate }} </div><br>
      <div class="term">Residual Value</div>
      <div class="definition"> {{ 'Glossary.ResidualValue1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ResidualValue2' | translate }} </div><br>
      <div class="term">Reinstallment Contract</div>
      <div class="definition"> {{ 'Glossary.RetailInstallmentContract' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="S" class="single-letter">S</div>
      <div class="term">Sales Tax</div>
      <div class="definition"> {{ 'Glossary.SalesTax' | translate }} </div><br>
      <div class="term">Sales Tax Exemption</div>
      <div class="definition"> {{ 'Glossary.SalesTaxExemption' | translate }} </div><br>
      <div class="term">Secretary's Certificate (Corporate Resolution)</div>
      <div class="definition"> {{ 'Glossary.SecretaryCertificate' | translate }} </div><br>
      <div class="term">Simple Interest</div>
      <div class="definition"> {{ 'Glossary.SimpleInterest' | translate }} </div><br>
      <div class="term">Skip Payment</div>
      <div class="definition"> {{ 'Glossary.SkipPayment' | translate }} </div><br>
      <div class="term">Sole Proprietorship</div>
      <div class="definition"> {{ 'Glossary.SoleProprietorship' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>

      <div id="T" class="single-letter">T</div>
      <div class="term">Tax Exempt Organization</div>
      <div class="definition"> {{ 'Glossary.TaxExemptOrganization' | translate }} </div><br>
      <div class="term">Term</div>
      <div class="definition"> {{ 'Glossary.Term' | translate }} </div><br>
      <div class="term">TRAC (Terminal Rental Adjustment Clause) Lease, Option Lease</div>
      <div class="definition"> {{ 'Glossary.TRACLease' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>      

      <div id="U" class="single-letter">U</div>
      <div class="term">Usury Laws</div>
      <div class="definition"> {{ 'Glossary.UsuryLaws' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>      

      <div id="V" class="single-letter">V</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      <div id="W" class="single-letter">W</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      <div id="X" class="single-letter">X</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      <div id="Y" class="single-letter">Y</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>
      <div id="Z" class="single-letter">Z</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Back to Top</a>&nbsp;<br>
      <hr>      
    </div>
 
    <div class="container" *ngIf="isCanadaFrench">
      <br>
      <br>
      <br>
      <div class="letterlinks">
         <h5 id="top"></h5>
         <a class="letterlinks" href="javascript:document.getElementById('A').scrollIntoView(true);" style="text-decoration: underline;">A</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('B').scrollIntoView(true);" style="text-decoration: underline;">B</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('C').scrollIntoView(true);" style="text-decoration: underline;">C</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('D').scrollIntoView(true);" style="text-decoration: underline;">D</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('E').scrollIntoView(true);" style="text-decoration: underline;">E</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('F').scrollIntoView(true);" style="text-decoration: underline;">F</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('G').scrollIntoView(true);" style="text-decoration: underline;">G</a>&nbsp;      
         <a class="letterlinks">H</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('I').scrollIntoView(true);" style="text-decoration: underline;">I</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('J').scrollIntoView(true);" style="text-decoration: underline;">J</a>&nbsp;
         <a class="letterlinks">K</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('L').scrollIntoView(true);" style="text-decoration: underline;">L</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('M').scrollIntoView(true);" style="text-decoration: underline;">M</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('N').scrollIntoView(true);" style="text-decoration: underline;">N</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('O').scrollIntoView(true);" style="text-decoration: underline;">O</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('P').scrollIntoView(true);" style="text-decoration: underline;">P</a>&nbsp;
         <a class="letterlinks">Q</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('R').scrollIntoView(true);" style="text-decoration: underline;">R</a>&nbsp;
         <a class="letterlinks" href="javascript:document.getElementById('S').scrollIntoView(true);" style="text-decoration: underline;">S</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('T').scrollIntoView(true);" style="text-decoration: underline;">T</a>&nbsp;
         <a class="letterlinks">U</a>&nbsp;      
         <a class="letterlinks" href="javascript:document.getElementById('V').scrollIntoView(true);" style="text-decoration: underline;">V</a>&nbsp;
         <a class="letterlinks">W</a>&nbsp;      
         <a class="letterlinks">X</a>&nbsp;
         <a class="letterlinks">Y</a>&nbsp;      
         <a class="letterlinks">Z</a>&nbsp;
      </div>
      <br>
      <br>

      <div id ="A" class="single-letter">A</div><br>
      <div class="term">Acte de vente</div>
      <div class="definition"> {{ 'Glossary.ActeVente' | translate }} </div><br>
      <div class="term">Actifs</div>
      <div class="definition"> {{ 'Glossary.Actifs' | translate }} </div><br>
      <div class="term">Affiliée</div>
      <div class="definition"> {{ 'Glossary.Affiliée' | translate }} </div><br>
      <div class="term">Ajouts</div>
      <div class="definition"> {{ 'Glossary.Ajouts' | translate }} </div><br>
      <div class="term">Annexe de bail</div>
      <div class="definition"> {{ 'Glossary.AnnexeBail' | translate }} </div><br>
      <div class="term">Amortissement</div>
      <div class="definition"> {{ 'Glossary.Amortissement' | translate }} </div><br>
      <div class="term">Arrérages (versements)</div>
      <div class="definition"> {{ 'Glossary.Arrérages' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="B" class="single-letter">B</div>
      <div class="term">Bail à JVM (Juste valeur marchande) - Crédit-bail non plafonné</div>
      <div class="definition"> {{ 'Glossary.BailJVM' | translate }} </div><br>
      <div class="term">Bail Option</div>
      <div class="definition"> {{ 'Glossary.BailOption' | translate }} </div><br>
      <div class="term">Bail TRAC, Bail Option</div>
      <div class="definition"> {{ 'Glossary.BailTRAC' | translate }} </div><br>
      <div class="term">Bénéficiaire</div>
      <div class="definition"> {{ 'Glossary.Bénéficiaire' | translate }} </div><br>
      <div class="term">Bien offert en garantie</div>
      <div class="definition"> {{ 'Glossary.BienOffert' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="C" class="single-letter">C</div>
      <div class="term">Calendrier/Cédule de paiements</div>
      <div class="definition"> {{ 'Glossary.Calendrier' | translate }} </div><br>
      <div class="term">Capital</div>
      <div class="definition"> {{ 'Glossary.Capital' | translate }} </div><br>
      <div class="term">Cautionnement permanent</div>
      <div class="definition"> {{ 'Glossary.CautionnementPermanent' | translate }} </div><br>
      <div class="term">Cautionnement personnel</div>
      <div class="definition"> {{ 'Glossary.CautionnementPersonnel' | translate }} </div><br>
      <div class="term">Certificat d'impôt au prorata</div>
      <div class="definition"> {{ 'Glossary.CertificatProrata' | translate }} </div><br>
      <div class="term">Certificat du secrétaire (Résolution de l'entreprise)</div>
      <div class="definition"> {{ 'Glossary.CertificatSecrétaire' | translate }} </div><br>
      <div class="term">Contrat à versements reportés</div>
      <div class="definition"> {{ 'Glossary.ContratVersements' | translate }} </div><br>
      <div class="term">Contrat de crédit-bail plafonné</div>
      <div class="definition"> {{ 'Glossary.ContratBail1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ContratBail2' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ContratBail3' | translate }} </div><br>
      <div class="term">Contrat de crédit-bail (non plafonné)</div>
      <div class="definition"> {{ 'Glossary.ContratCredit1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ContratCredit2' | translate }} </div><br>
      <div class="term">Contrat de location-acquisition</div>
      <div class="definition"> {{ 'Glossary.ContratAcquisition' | translate }} </div><br>
      <div class="term">Contrat de location-exploitation</div>
      <div class="definition"> {{ 'Glossary.ContratExploitation' | translate }} </div><br>
      <div class="term">Contrat de vente à tempérament au détail</div>
      <div class="definition"> {{ 'Glossary.ContratVente' | translate }} </div><br>
      <div class="term">Contre-garantie corporative</div>
      <div class="definition"> {{ 'Glossary.Contre-garantieCorporative' | translate }} </div><br>
      <div class="term">Coût capitalisé</div>
      <div class="definition"> {{ 'Glossary.CoûtCapitalisé' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="D" class="single-letter">D</div>
      <div class="term">Date de prise d'effet</div>
      <div class="definition"> {{ 'Glossary.DatePrise' | translate }} </div><br>
      <div class="term">Délai de grâce</div>
      <div class="definition"> {{ 'Glossary.DélaiGrâce' | translate }} </div><br>
      <div class="term">Demande</div>
      <div class="definition"> {{ 'Glossary.Demande' | translate }} </div><br>
      <div class="term">Détenteur de privilège</div>
      <div class="definition"> {{ 'Glossary.DétenteurPrivilège' | translate }} </div><br>
      <div class="term">Dette</div>
      <div class="definition"> {{ 'Glossary.Dette' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>    

      <div id="E" class="single-letter">E</div>
      <div class="term">Échéance</div>
      <div class="definition"> {{ 'Glossary.Échéance' | translate }} </div><br>
      <div class="term">Échéance de location</div>
      <div class="definition"> {{ 'Glossary.ÉchéanceLocation' | translate }} </div><br>
      <div class="term">Entreprise individuelle</div>
      <div class="definition"> {{ 'Glossary.EntrepriseIndividuelle' | translate }} </div><br>
      <div class="term">Équipements</div>
      <div class="definition"> {{ 'Glossary.Équipements' | translate }} </div><br>
      <div class="term">États financiers</div>
      <div class="definition"> {{ 'Glossary.ÉtatsFinanciers' | translate }} </div><br>
      <div class="term">Exonération de taxe sur les ventes</div>
      <div class="definition"> {{ 'Glossary.Exonération' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="F" class="single-letter">F</div>
      <div class="term">Facteur de taux</div>
      <div class="definition"> {{ 'Glossary.FacteurTaux' | translate }} </div><br>
      <div class="term">Faillite</div>
      <div class="definition"> {{ 'Glossary.Faillite' | translate }} </div><br>
      <div class="term">Frais de retard</div>
      <div class="definition"> {{ 'Glossary.FraisRetard' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="G" class="single-letter">G</div>
      <div class="term">GAP</div>
      <div class="definition"> {{ 'Glossary.GAP' | translate }} </div><br>
      <div class="term">Garant</div>
      <div class="definition"> {{ 'Glossary.Garant' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="H" class="single-letter">H</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="I" class="single-letter">I</div>
      <div class="term">Intérêt</div>
      <div class="definition"> {{ 'Glossary.Intérêt' | translate }} </div><br>
      <div class="term">Intérêt simple</div>
      <div class="definition"> {{ 'Glossary.IntérêtSimple' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="J" class="single-letter">J</div>
      <div class="term">Juste valeur marchande</div>
      <div class="definition"> {{ 'Glossary.JVM1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.JVM2' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="K" class="single-letter">K</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>
      
      <div id="L" class="single-letter">L</div>
      <div class="term">Locataire</div>
      <div class="definition"> {{ 'Glossary.Locataire1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Locataire2' | translate }} </div><br>
      <div class="term">Location</div>
      <div class="definition"> {{ 'Glossary.Location1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Location2' | translate }} </div><br>
      <div class="term">Location principale</div>
      <div class="definition"> {{ 'Glossary.LocationPrincipale' | translate }} </div><br>
      <div class="term">Lois sur l'usure</div>
      <div class="definition"> {{ 'Glossary.LoisUsure' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="M" class="single-letter">M</div>
      <div class="term">Manquement</div>
      <div class="definition"> {{ 'Glossary.Manquement' | translate }} </div><br>
      <div class="term">Mauvaises créances</div>
      <div class="definition"> {{ 'Glossary.MauvaisesCréances' | translate }} </div><br>
      <div class="term">Mouvements de trésorerie</div>
      <div class="definition"> {{ 'Glossary.MouvementsTrésorerie1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.MouvementsTrésorerie2' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="N" class="single-letter">N</div>
      <div class="term">Note de couverture</div>
      <div class="definition"> {{ 'Glossary.NoteCouverture' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="O" class="single-letter">O</div>
      <div class="term">Obligation</div>
      <div class="definition"> {{ 'Glossary.Obligation' | translate }} </div><br>
      <div class="term">Obsolescence</div>
      <div class="definition"> {{ 'Glossary.Obsolescence' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="P" class="single-letter">P</div>
      <div class="term">Partenaire</div>
      <div class="definition"> {{ 'Glossary.Partenaire' | translate }} </div><br>
      <div class="term">Perte</div>
      <div class="definition"> {{ 'Glossary.Perte' | translate }} </div><br>
      <div class="term">Plafond (Cap)</div>
      <div class="definition"> {{ 'Glossary.Plafond' | translate }} </div><br>
      <div class="term">PPSA</div>
      <div class="definition"> {{ 'Glossary.PPSA' | translate }} </div><br>
      <div class="term">Prêteur</div>
      <div class="definition"> {{ 'Glossary.Prêteur' | translate }} </div><br>
      <div class="term">Privilège</div>
      <div class="definition"> {{ 'Glossary.Privilège' | translate }} </div><br>
      <div class="term">Procuration</div>
      <div class="definition"> {{ 'Glossary.Procuration' | translate }} </div><br>
      <div class="term">Prolongations</div>
      <div class="definition"> {{ 'Glossary.Prolongations' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="Q" class="single-letter">Q</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="R" class="single-letter">R</div>
      <div class="term">Rachat</div>
      <div class="definition"> {{ 'Glossary.Rachat' | translate }} </div><br>
      <div class="term">Référence de solvabilité</div>
      <div class="definition"> {{ 'Glossary.RéférenceSolvabilité' | translate }} </div><br>
      <div class="term">Remboursement</div>
      <div class="definition"> {{ 'Glossary.Remboursement1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Remboursement2' | translate }} </div>
      <div class="definition"> {{ 'Glossary.Remboursement3' | translate }} </div><br>
      <div class="term">Reprise de possession</div>
      <div class="definition"> {{ 'Glossary.ReprisePossession' | translate }} </div><br>
      <div class="term">Résolution de l'entreprise</div>
      <div class="definition"> {{ 'Glossary.RésolutionEntreprise' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="S" class="single-letter">S</div>
      <div class="term">Secrétaire de direction</div>
      <div class="definition"> {{ 'Glossary.SecrétaireDirection' | translate }} </div><br>
      <div class="term">Société</div>
      <div class="definition"> {{ 'Glossary.Société' | translate }} </div><br>
      <div class="term">Société à responsabilité limitée (SARL)</div>
      <div class="definition"> {{ 'Glossary.Société(SARL)' | translate }} </div><br>
      <div class="term">Société en commandite simple</div>
      <div class="definition"> {{ 'Glossary.SociétéCommanditeSimple' | translate }} </div><br>
      <div class="term">Société en nom collectif</div>
      <div class="definition"> {{ 'Glossary.SociétéCollectif' | translate }} </div><br>
      <div class="term">Société exonérée d'impôt</div>
      <div class="definition"> {{ 'Glossary.SociétéImpôt' | translate }} </div><br>
      <div class="term">Société filiale de crédit</div>
      <div class="definition"> {{ 'Glossary.SociétéCrédit' | translate }} </div><br>
      <div class="term">Société mère</div>
      <div class="definition"> {{ 'Glossary.SociétéMère' | translate }} </div><br>
      <div class="term">Solde déficitaire</div>
      <div class="definition"> {{ 'Glossary.SoldeDéficitaire' | translate }} </div><br>
      <div class="term">Suite de versements</div>
      <div class="definition"> {{ 'Glossary.SuiteVersements' | translate }} </div><br>
      <div class="term">S/N</div>
      <div class="definition"> {{ 'Glossary.S/N' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="T" class="single-letter">T</div>
      <div class="term">Taux fixe</div>
      <div class="definition"> {{ 'Glossary.TauxFixe' | translate }} </div><br>
      <div class="term">Taux flottant</div>
      <div class="definition"> {{ 'Glossary.TauxFlottant1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.TauxFlottant2' | translate }} </div><br>
      <div class="term">Taxe de vente</div>
      <div class="definition"> {{ 'Glossary.TaxeVente' | translate }} </div><br>
      <div class="term">Terme</div>
      <div class="definition"> {{ 'Glossary.Terme' | translate }} </div><br>
      <div class="term">Titre juridique/Titre de propriété</div>
      <div class="definition"> {{ 'Glossary.Titre' | translate }} </div><br>
      <div class="term">Transfert électronique de fonds (TEF)</div>
      <div class="definition"> {{ 'Glossary.TEF' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>      

      <div id="U" class="single-letter">U</div>      
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>      

      <div id="V" class="single-letter">V</div>
      <div class="term">Valeur acquise (Valeur capitalisée)</div>
      <div class="definition"> {{ 'Glossary.ValeurAcquise' | translate }} </div><br>
      <div class="term">Valeur résiduelle</div>
      <div class="definition"> {{ 'Glossary.ValeurResiduelle1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.ValeurResiduelle2' | translate }} </div><br>
      <div class="term">Versements accélérés</div>
      <div class="definition"> {{ 'Glossary.VersementsAccélérés' | translate }} </div><br>
      <div class="term">Versement anticipé</div>
      <div class="definition"> {{ 'Glossary.VersementAnticipé' | translate }} </div><br>
      <div class="term">Versements anticipés</div>
      <div class="definition"> {{ 'Glossary.VersementsAnticipés' | translate }} </div><br>
      <div class="term">Versement arriéré</div>
      <div class="definition"> {{ 'Glossary.VersementArriéré' | translate }} </div><br>
      <div class="term">Versements de location</div>
      <div class="definition"> {{ 'Glossary.VersementsLocation' | translate }} </div><br>
      <div class="term">Versement forfaitaire</div>
      <div class="definition"> {{ 'Glossary.VersementForfaitaire1' | translate }} </div>
      <div class="definition"> {{ 'Glossary.VersementForfaitaire2' | translate }} </div><br>
      <div class="term">Versement initial</div>
      <div class="definition"> {{ 'Glossary.VersementInitial' | translate }} </div><br>
      <div class="term">Versement mensuel</div>
      <div class="definition"> {{ 'Glossary.VersementMensuel' | translate }} </div><br>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>

      <div id="W" class="single-letter">W</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>
      <div id="X" class="single-letter">X</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>
      <div id="Y" class="single-letter">Y</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>
      <div id="Z" class="single-letter">Z</div>
      <a class ="scrolllinks" href="javascript:document.getElementById('top').scrollIntoView(true);">^ Retour au sommet</a>&nbsp;<br>
      <hr>



    </div>
   </div>





